(function () {
  /**
   * @awaitingdeprecation
   */
  angular.module('binky.core.user.avatar').constant('USER_AVATAR_CACHE_ID', 'UserAvatar');
})();
